// @flow

import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';
import GrossRentsService from '../../../services/grossRentsService';
import useAbortController from '../../../hooks/useAbortController';
import type { EditGrossRentCertificationMutationVariables } from './types';

const grossRentsService = new GrossRentsService();

const useEditGrossRentCertificationMutation = ({
  propertyId,
  organizationId,
  options,
}: {
  propertyId: string,
  organizationId: string,
  options?: UseMutationOptions<
    Object,
    mixed,
    EditGrossRentCertificationMutationVariables,
    mixed,
  >,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(
    async ({
      affordableQualificationId,
      ...payload
    }: EditGrossRentCertificationMutationVariables) => {
      return grossRentsService.editGrossRentCertification(
        organizationId,
        propertyId,
        affordableQualificationId,
        payload,
        abortControllerOptions,
      );
    },
    options,
  );
};

export default useEditGrossRentCertificationMutation;
